/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { Loader } from "..";
import { FaMobileScreen } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import { IoPeople } from "react-icons/io5";
import { MdElevator } from "react-icons/md";
import { PiClockUserFill } from "react-icons/pi";
import { TiStar } from "react-icons/ti";
import { getEdificios } from "../../utils";
import { getLocale } from "../../utils/getLocale";
import "./stylesFichaEdificioInventario.scss";

export const FichaEdificioInventario = ({ id, pais }) => {
  const [edificio, setEdificio] = useState(null);
  const [imageSrc, setImageSrc] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initialize = async () => {
      try {
        setLoading(true);
        const allEdificios = await getEdificios({ pais });
        const selectedEdificio = allEdificios.find((edificio) => edificio.id.toString() === id.toString());
        if (selectedEdificio) {
          setEdificio(selectedEdificio);
          let src = null;
          try {
            const pngSrc = await import(`../../img/edificios/${selectedEdificio.id}.png`);
            src = pngSrc.default;
          } catch {
            try {
              const jpgSrc = await import(`../../img/edificios/${selectedEdificio.id}.jpeg`);
              src = jpgSrc.default;
            } catch {
              src = null;
            }
          }
          setImageSrc({ [selectedEdificio.id]: src });
        } else {
          setError(`Edificio con ID ${id} no encontrado`);
        }
      } catch (error) {
        console.error("Error loading building data:", error);
        setError("Error cargando datos del edificio");
      } finally {
        setLoading(false);
      }
    };
    initialize();
  }, [pais, id]);

  const renderEmpresasInfo = (empresaslistado) => {
    if (!empresaslistado || empresaslistado.toUpperCase() === "NO DISPONIBLE") {
      return "NO DISPONIBLE";
    }
    const cantidad = empresaslistado.split(",").length;
    return `${cantidad} EMPRESAS`;
  };

  if (loading) return <Loader />;
  if (error) return <div>{error}</div>;
  if (!edificio) return <div>No se encontró el edificio.</div>;

  return (
    <div className="body-ficha">
      <div key={edificio.id} className="ficha-edificios">
        {imageSrc[edificio.id] && (
          <img className="edificios-imagen-edificio" src={imageSrc[edificio.id]} alt={edificio.edificio} />
        )}
        <div className="nombre-edificio"> {edificio.edificio || ""} </div>
        <div className="div-ubicacion">
          <FaLocationDot className="ubicacion-icono" />
          <div className="ubicacion-texto">
            {edificio.direccion.toUpperCase()}, {edificio.ubicacion}
          </div>
          {/* <div className="ubicacion-bajada">{edificio.ubicacion}</div> */}
        </div>
        <div className="div-ascensores">
          <MdElevator className="ascensores-icono" />
          <div className="ascensores-texto">
            {edificio.pantallas ? `${edificio.pantallas} ASCENSORES con pantallas FULLHD` : "-"}
          </div>
        </div>
        <div className="div-totems">
          <FaMobileScreen className="totems-icono" />
          <div className="totems-texto">
            {edificio.totems || edificio.cowork
              ? `${edificio.totems || edificio.cowork} ${edificio.totems || edificio.cowork > 1 ? "TÓTEMS de circulación" : "TÓTEM de circulación"}`
              : "-"}
          </div>
        </div>
        <div className="div-espera">
          <PiClockUserFill className="espera-icono" />
          <div className="espera-texto">
            {edificio.espera
              ? `${edificio.espera} ${edificio.espera > 1 ? "PANTALLAS en hall de espera" : "PANTALLA en hall de espera"}`
              : "-"}
          </div>
        </div>
        <div className="contenedor-blanco">
          <div className="div-people">
            <IoPeople className="people-icono" />
            <div className="people-numero">{edificio.personas.toLocaleString(getLocale(pais))}</div>
            <div className="people-texto">PERSONAS ÚNICAS DIARIAS</div>
          </div>
          <div className="div-empresas">
            <HiOutlineBuildingOffice className="empresas-icono" />
            <div className="empresas-texto">{renderEmpresasInfo(edificio.empresaslistado)}</div>
          </div>
          <div className="div-empresas-destacadas">
            <TiStar className="empresas-destacadas-icono" />
            <div className="empresas-destacadas-texto">{(edificio.empresasdestacadas || "").toUpperCase()}</div>
          </div>
          <div className="linea-vertical" />
        </div>
      </div>
    </div>
  );
};
